/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum IndicatorRelationStatus {
    TODO = 'TODO',
    ERROR = 'ERROR',
    DONE = 'DONE',
}
